"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzSelect = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));
var SzCheckbox_1 = __importDefault(require("../SzCheckbox/SzCheckbox"));
var SzInput_1 = __importDefault(require("../SzInput/SzInput"));
var SzButton_1 = __importDefault(require("../SzButton/SzButton"));
var classnames_1 = __importDefault(require("classnames"));
var SzSelect_style_1 = __importDefault(require("./SzSelect.style"));
require("./SzSelect.scss");
function reducer(state, action) {
    switch (action.type) {
        case 'set':
            return __spread(state, [action.option]);
        case 'remove':
            var index = state.indexOf(action.option);
            state.splice(index, 1);
            return state;
        case 'reset':
            return [];
    }
}
function SzSelect(_a) {
    var id = _a.id, options = _a.options, value = _a.value, className = _a.className, isDisabled = _a.isDisabled, isMulti = _a.isMulti, isMultiList = _a.isMultiList, isSearchable = _a.isSearchable, name = _a.name, onChange = _a.onChange, placeholder = _a.placeholder, isClearable = _a.isClearable, defaultOptions = _a.defaultOptions;
    var initialState = [];
    var _b = __read(react_1.useReducer(reducer, initialState), 2), selectedValues = _b[0], setSelectedValues = _b[1];
    var defaultClass = 'sz-select-custom';
    var _c = __read(react_1.useState(false), 2), showList = _c[0], setShowList = _c[1];
    var _d = __read(react_1.useState(''), 2), searchValue = _d[0], setSearchValue = _d[1];
    if (isMultiList) {
        var clearValue = function () {
            setSearchValue('');
            setSelectedValues({ type: 'reset', option: [] });
        };
        var onInputChange = function (_a) {
            var target = _a.target;
            return setSearchValue(target.value);
        };
        var onFocus = function () { return setShowList(true); };
        var onBlur = function () {
            var blur = setTimeout(function () {
                setShowList(false);
                clearTimeout(blur);
            }, 150);
        };
        var filteredValue = options.filter(function (_a) {
            var value = _a.value, label = _a.label;
            return ~value.indexOf(searchValue) | ~label.indexOf(searchValue);
        });
        var nbSelected = selectedValues.length + " s\u00E9lectionn\u00E9s";
        var inputClasses = classnames_1.default('sz-select-custom__input bg-white border', {
            filled: selectedValues.length > 0
        });
        var placeholderValue = selectedValues.length === 0
            ? placeholder
            : selectedValues.length === 1
                ? selectedValues[0].label
                : nbSelected;
        var input = (react_1.default.createElement(SzInput_1.default, { onFocus: onFocus, onBlur: onBlur, value: searchValue, placeholder: placeholderValue, className: inputClasses, name: "sz-select-custom__input", readOnly: !isSearchable, onChange: onInputChange }));
        var Item_1 = function (_a) {
            var name = _a.name, label = _a.label, checked = _a.checked, onChange = _a.onChange, value = _a.value;
            return (react_1.default.createElement("div", { className: defaultClass + "__item p-2 d-flex align-items-stretch" + (checked ? ' checked' : '') },
                react_1.default.createElement(SzCheckbox_1.default, { className: "d-flex align-items-center w-100", id: name, name: name, value: value, label: label, checked: checked, onChange: onChange })));
        };
        var list = (react_1.default.createElement("div", { className: "sz-select-custom__wrapper-list position-absolute w-100 bg-white " + className }, (searchValue.length > 0 ? filteredValue : options).map(function (option, key) {
            var value = option.value, label = option.label;
            var checked = ~selectedValues.indexOf(option);
            var onCheckboxChange = function (_a) {
                var target = _a.target;
                setSelectedValues({
                    type: target.checked ? 'set' : 'remove',
                    option: option
                });
                setSearchValue('');
                setShowList(false);
            };
            return (react_1.default.createElement(Item_1, { key: key, onChange: onCheckboxChange, label: label, name: defaultClass + "-" + value, value: value, checked: checked }));
        })));
        return (react_1.default.createElement("div", { className: "position-relative" },
            input,
            showList && list,
            react_1.default.createElement("div", { className: "sz-select-custom__wrapper-icon position-absolute d-flex align-items-center justify-content-center" },
                isClearable && selectedValues.length > 0 && (react_1.default.createElement(SzButton_1.default, { onClick: clearValue, variant: "tertiary", icon: "remove", className: "sz-select-custom__icon-remove small" })),
                react_1.default.createElement("div", { className: "sz-select-custom__icon-chevron d-flex align-items-center justify-content-center" },
                    react_1.default.createElement(SzIcon_1.default, { variant: "bold", icon: "arrow-down-1", className: "small" })))));
    }
    return (react_1.default.createElement(react_select_1.default, { id: id, value: value, onChange: onChange, options: options, isSearchable: isSearchable, isDisabled: isDisabled, isMulti: isMulti, name: name, placeholder: placeholder, isClearable: isClearable, className: className, styles: SzSelect_style_1.default, defaultOptions: defaultOptions }));
}
exports.SzSelect = SzSelect;
exports.default = SzSelect;
